import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-float-card',
    templateUrl: './float-card.component.html',
    styleUrls: ['./float-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FloatCardComponent implements OnInit {
    //@Input() isDemoPage: boolean;
    constructor() {}

    ngOnInit(): void {}
}
